import React, { Fragment, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import CopyRight from "src/Components/Custom/CopyRight/CopyRight";
import Footer from "src/Components/Custom/Footer/Footer";
import NavBar from "src/Components/Custom/NavBar/NavBar";
import VerficationModal from "src/Components/Custom/VerificationModal/VerificationModal";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import useAuth from "src/Hooks/Custom/useAuth";
import useStateCity from "src/Hooks/Custom/useStateCity";
import { useTranslation } from "react-i18next";

function SignupPage() {
  const { t,i18n } = useTranslation();
  const { register, errors, handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      name: "",
      lastName: "",
      phone: "",
      email: "",
      password: "",
      state_id: "",
      city_id: "",
    },
    mode: "onChange",
  });
  const { stateData, cityData } = useStateCity(watch("state_id"));
  const state_id = watch("state_id");
  useEffect(() => {
    if (state_id) {
      setValue("city_id", "");
    }
  }, [setValue, state_id]);
  const {
    signup,
    loading,
    verificationLoading,
    verify,
    isVerificationVisible,
    setIsVerificationVisible,
  } = useAuth();
  const onSubmit = handleSubmit(signup);
  const history = useHistory();

  return (
    <Fragment>
      <header className="login_header">
        <NavBar />
        <section className="login_section">
          <div className="container">
            <div className={`${i18n.dir() ==='rtl'?'row-reverse text-right':'row'}`}>
              <div className="col-md-6">
                <div className="col_selector"></div>
              </div>
              <div className="col-md-5">
                <div className="col_selector">
                  <h2 className={`mb-2 text-right ${i18n.dir() === "rtl" ? "Almaraisemibold":"poppinssemibold"}`}>
                    {t("Account Setup")}
                  </h2>
                  <form className={i18n.dir() === "rtl" ? "Almaraisemibold":"poppinsregular"}>
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <input
                          type="text"
                          className={`form-control ${errors.name ? "is-invalid" : ""
                            }`}
                          placeholder={t("First Name")}
                          name={"name"}
                          ref={register({
                            required: {
                              value: true,
                              message: t("FirstName is required"),
                            },
                          })}
                        />
                        <VisibilityToggle visible={errors.name ? true : false}>
                          <p className="text-danger">{errors.name?.message}</p>
                        </VisibilityToggle>
                      </div>
                      <div className="form-group col-md-6">
                        <input
                          type="text"
                          className={`form-control ${errors.lastName ? "is-invalid" : ""
                            }`}
                          placeholder={t('Last Name')}
                          name={"lastName"}
                          ref={register({
                            required: {
                              value: true,
                              message: t("LastName is required"),
                            },
                          })}
                        />
                        <VisibilityToggle
                          visible={errors.lastName ? true : false}
                        >
                          <p className="text-danger">
                            {errors.lastName?.message}
                          </p>
                        </VisibilityToggle>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <input
                          type="email"
                          className={`form-control ${errors.email ? "is-invalid" : ""
                            }`}
                          placeholder={t("Email Address")}
                          name={"email"}
                          ref={register({
                            required: {
                              value: true,
                              message: t("Email is required"),
                            },
                            pattern: {
                              value: /[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})/,
                              message: t("Email Address is invalid"),
                            },
                          })}
                        />
                        <VisibilityToggle visible={errors.email ? true : false}>
                          <p className="text-danger">{errors.email?.message}</p>
                        </VisibilityToggle>
                      </div>
                      <div className="form-group col-md-6">
                        <input
                          type="password"
                          className={`form-control ${errors.password ? "is-invalid" : ""
                            }`}
                          placeholder={t("Password")}
                          name={"password"}
                          ref={register({
                            required: {
                              value: true,
                              message: t("Password is required"),
                            },
                            pattern: {
                              value: /(?=^.{8,}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s)[0-9a-zA-Z!*^?]/,
                              message:
                                t('Password is invalid, needs to have minimum eight characters, at least one uppercase letter, one lowercase letter and one number'),
                            },
                          })}
                        />
                        <VisibilityToggle
                          visible={errors.password ? true : false}
                        >
                          <p className="text-danger">
                            {errors.password?.message}
                          </p>
                        </VisibilityToggle>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <select
                          name={"state_id"}
                          className={`form-control ${errors.state_id ? "is-invalid" : ""
                            }`}
                          ref={register({
                            required: {
                              value: true,
                              message: t("Wilaya is required"),
                            },
                          })}
                        >
                          <option value="">{t('Select Wilaya')}</option>
                          {stateData.map((_: any, _i: number) => (
                            <option key={_i} value={_.id}>
                              {_.name}
                            </option>
                          ))}
                        </select>
                        <VisibilityToggle
                          visible={errors.state_id ? true : false}
                        >
                          <p className="text-danger">
                            {errors.state_id?.message}
                          </p>
                        </VisibilityToggle>
                      </div>
                      <div className="form-group col-md-6">
                        <select
                          name={"city_id"}
                          className={`form-control ${errors.city_id ? "is-invalid" : ""
                            }`}
                          ref={register({
                            required: {
                              value: true,
                              message: t("Daira is required"),
                            },
                          })}
                        >
                          <option value="">{t("Select your Daira")}</option>
                          {cityData.map((_: any, _i: number) => (
                            <option key={_i} value={_.id}>
                              {_.name}
                            </option>
                          ))}
                        </select>
                        <VisibilityToggle
                          visible={errors.city_id ? true : false}
                        >
                          <p className="text-danger">
                            {errors.city_id?.message}
                          </p>
                        </VisibilityToggle>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <input
                          type="text"
                          className={`form-control ${errors.phone ? "is-invalid" : ""
                            }`}
                          placeholder={t("Phone Number")}
                          ref={register({
                            required: {
                              value: true,
                              message: t("Phone Number is required"),
                            },
                            pattern: {
                              value: /^[0-9]{6,}$/,
                              message: t('Phone Number is invalid')
                            }
                          })}
                          name={"phone"}
                        />
                        <VisibilityToggle visible={errors.phone ? true : false}>
                          <p className="text-danger">{errors.phone?.message}</p>
                        </VisibilityToggle>
                      </div>
                      <div className="form-group col-md-6">
                        <button
                          disabled={loading}
                          className="btn custom_btn w-100"
                          onClick={onSubmit}
                        >
                          <VisibilityToggle visible={loading}>
                            <span className="spinner-border spinner-border-sm"></span>
                            &nbsp;
                          </VisibilityToggle>
                          {t("Sign Up")}
                        </button>
                      </div>
                    </div>
                    <div>
                      <p className={`text-right fz14 poppinsregular ${i18n.dir() === "rtl" ? "Almarairegular":""}`}>
                        {" "}
                        {t("By clicking Sign up, you agree to our")}{" "}
                        <Link to={"/terms-and-condition"} className="base_color ml-1 ">
                          {t("Terms and Conditions")}
                        </Link>
                        {" "}
                        {t("and that you have read our")}{" "}
                        <Link to={"/privacy-policy"} className="base_color ml-1">
                          {t("Privacy Policy")}
                        </Link>

                      </p>
                      <p className={`text-right fz14 poppinsregular ${i18n.dir() === "rtl" ? "Almaraisemibold":"poppinsregular"}`}>
                        {t("Already have an account ?")}{" "}
                        <Link to={"/login"} className="font-weight-bold ml-1">
                          {t("Login")}
                        </Link>
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </header>
      <Footer />
      <CopyRight />
      <VerficationModal
        email={watch("email")}
        cb={() => history.push("/login")}
        verificationLoading={verificationLoading}
        verify={verify}
        isVerificationVisible={isVerificationVisible}
        setIsVerificationVisible={setIsVerificationVisible}
      />
    </Fragment>
  );
}

export default SignupPage;
